import React from "react";
import { Typography, Box } from "@material-ui/core";

export const LoginRequired = (): JSX.Element => {
  return (
    <Box alignSelf="center" textAlign="center">
      <Typography variant="h3">Kirjaudu sisään painamalla ylälaidan painiketta</Typography>
    </Box>
  );
};
